'use strict';

import { view } from '@/functions';

const prefix = '/direct-debits';
export default [
    {
        path: prefix,
        name: 'direct-debits',
        meta: {
            title: 'Direct debits',
            scopes: ['read_direct_debits', 'write_direct_debits']
        },
        component: () => view('direct-debits/index')
    },
    {
        path: `${prefix}/info`,
        name: 'direct-debits-info',
        meta: {
            title: 'Direct debits',
            scopes: ['read_direct_debits', 'write_direct_debits']
        },
        component: () => view('direct-debits/info')
    },
];
